import React from 'react'

const Contact = () => {
    return (
        <section id="contact" class="contact">
            <div class="container">
                <div class="section-title">
                    <h2>Contact</h2>
                    <p>To find solutions to common problems, or place an order, contact us.</p>
                </div>
                <div class="row" data-aos="fade-in">
                    <div class="col-lg-5 d-flex align-items-stretch">
                        <div class="info">
                            <div class="address"> <i class="bi bi-geo-alt"></i>
                                <h4>Location:</h4>
                                <p>Peshawar, Pakistan</p>
                            </div>
                            <div class="email"> <i class="bi bi-envelope"></i>
                                <h4>Email:</h4>
                                <p>saqibdiar.uet@gmail.com</p>
                            </div>
                            <div class="phone"> <i class="bi bi-phone"></i>
                                <h4>Call:</h4>
                                <p>+92 324 9088331</p>
                            </div>
                             <iframe
                                src="https://www.google.com/maps/place/Peshawar+Ring+Rd.,+Peshawar,+Khyber+Pakhtunkhwa,+Pakistan/@33.9769458,71.5492928,17z/data=!3m1!4b1!4m5!3m4!1s0x38d917a2f2ba3357:0x5a07449d8145f9fb!8m2!3d33.9769414!4d71.5514815"
                                frameborder="0" width={300} height={300} allowFullScreen
                                >
                                    
                                </iframe>
                        </div>
                    </div>
                    <div class="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
                        <form class="php-email-form">
                            <div class="row">
                                <div class="form-group col-md-6"> <label for="name">Your Name</label> <input type="text"
                                    name="name" class="form-control" id="name" required /></div>
                                <div class="form-group col-md-6"> <label for="name">Your Email</label> <input
                                    type="email" class="form-control" name="email" id="email" required /></div>
                            </div>
                            <div class="form-group"> <label for="name">Subject</label> <input type="text"
                                class="form-control" name="subject" id="subject" required /></div>
                            <div class="form-group"> <label for="name">Message</label><textarea class="form-control"
                                name="message" rows="10" required></textarea></div>
                            <div class="my-3">
                                <div class="loading">Loading</div>
                                <div class="error-message"></div>
                                <div class="sent-message">Your message has been sent. Thank you!</div>
                            </div>
                            <div class="text-center"><button type="submit">Send Message</button></div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contact